import styled from "styled-components/macro";

import { Row } from "components/Layout";

export const FormRow = styled(Row).attrs({
  fullWidth: true,
  flex: true,
  alignCenter: true,
  justifyBetween: true,
  marginVertical: 2,
})``;
